import { ReactComponent as LogoWhite } from "./svg/tincode-white.svg";
import authBg from "./jpg/auth-bg.jpg";
import homeBanner from "./jpg/home-banner.jpg";
import noAvatar from "./jpg/no-avatar.jpg";
import academyLogo from "./png/academy-logo.png";
import avatar1 from "./png/avatar1.png";
import avatar2 from "./png/avatar2.png";
import avatar3 from "./png/avatar3.png";
import avatar4 from "./png/avatar4.png";
import avatar5 from "./png/avatar5.png";
import avatar6 from "./png/avatar6.png";

const Icon = {
  LogoWhite,
};

const image = {
  authBg,
  homeBanner,
  noAvatar,
  academyLogo,
  avatar1,
  avatar2,
  avatar3,
  avatar4,
  avatar5,
  avatar6,
};

export { Icon, image };
